import { render, staticRenderFns } from "./SalesManagement.vue?vue&type=template&id=46d034fa&scoped=true&"
import script from "./SalesManagement.vue?vue&type=script&lang=ts&"
export * from "./SalesManagement.vue?vue&type=script&lang=ts&"
import style0 from "./SalesManagement.vue?vue&type=style&index=0&id=46d034fa&lang=scss&scoped=true&"
import style1 from "./SalesManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d034fa",
  null
  
)

export default component.exports